export default "/images/vendor/flag-icon-css/flags/4x3/hk.svg?f4b6713db5e5a4773e9594cc69ed4ba3";